export default {
  SET_INSTITUTION_CONFIGURATION(state, data) {
    state.institutionConfiguration = data;
  },
  SET_TOPIC_TYPES(state, data) {
    state.topicTypes = data;
  },
  SET_TOPIC_TYPES_REQUEST(state, data) {
    state.topicTypesRequest = data;
  },
  SET_TOPIC_TYPES_ICONS(state, data) {
    state.topicTypesIcons = data;
  },
  SET_TOPIC_TYPES_COLORS(state, data) {
    state.topicTypesColors = data;
  },
  SET_TOPIC_TYPES_NAMES(state, data) {
    state.topicTypesNames = data;
  }
};
